const agrrementButtons = [
  {
    id: "true",
    label:
      "Yes, go paperless when possible. Email me when there are documents to look at online.",
  },
  {
    id: "false",
    label: "No, send all documents by U.S. Mail.",
  },
];

export const CONSTANTS = {
agrrementButtons,
};